import type { ResolvedComponent } from '@inertiajs/react';
import { ServiceDetail } from '@/components/services/ServiceDetail';
import { Button } from '@/components/ui/Button';
import { PageHeader } from '@/components/ui/PageHeader';
import { RevealOnScroll } from '@/components/ui/RevealOnScroll';
import { ServicesCatalog } from '@/data/services';
import { trackUmamiEvent } from '@/lib/analytics';

const wrap = 'mx-auto max-w-[1120px] px-5 md:px-10';
const sectionClassName = 'border-line border-t py-[52px] md:py-20';

const Services: ResolvedComponent = () => (
  <>
    <div className={wrap}>
      <PageHeader
        eyebrow="What we offer"
        spark
        title={
          <>
            Services shaped around your <em>space</em>.
          </>
        }
        lead="From weekly upkeep to a one-off reset, each visit is planned to your home or workplace — nothing generic, nothing rushed."
      />
    </div>

    {/* Service details */}
    <RevealOnScroll>
      <section className="pt-6 pb-[52px] md:pb-20">
        <div className={wrap}>
          <div className="border-line border-t">
            {ServicesCatalog.map(({ title, description }, index) => (
              <ServiceDetail
                key={title}
                n={String(index + 1).padStart(2, '0')}
                title={title}
                description={description}
              />
            ))}
          </div>
        </div>
      </section>
    </RevealOnScroll>

    {/* Closing CTA */}
    <RevealOnScroll>
      <section className={sectionClassName}>
        <div className={wrap}>
          <h2 className="t-h2 [&_em]:text-primary-deep mb-6 [&_em]:italic">
            Not sure which fits? <em>Let's talk it through.</em>
          </h2>
          <Button
            variant="solid"
            as="link"
            href="/contact"
            onClick={() => trackUmamiEvent('cta_request_visit', { location: 'services' })}
          >
            Request a visit
          </Button>
        </div>
      </section>
    </RevealOnScroll>
  </>
);

export default Services;
